module.exports = __webpack_public_path__ + "img/gratification-transfer.3eae394c.svg";